var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{staticClass:"dialog",attrs:{"visible":_vm.visible,"title":_vm.titles[_vm.type],"width":"1000px"},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.close}},[_c(_vm.type,{tag:"component",attrs:{"param":_vm.param,"close":_vm.close,"change":_vm.change}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }